import { useEffect, useRef, useState } from "react";
import AddIcon from '@mui/icons-material/Add';
import ProgressBarODM from "./ProgressBar";
import { assetti, esecuzioni, Esercizio, finalita, modalita } from "../interfaces/Esercizio";
import CompartiMuscolari, { comparti } from "./CompartiMuscolari";
import ImageUploadPreview from "./ImageUploadPreview";
import ModalPosizioneFinalita from "./ModalPosizioneFinalità";
import EsercizioCorrelato from "./EsercizioCorrelato"
import ComplexFunctionModal from "./ComplexFunctionModal";
import ModeIcon from '@mui/icons-material/Mode';
import IssueHandlingModal from "./IssueHandlingModal";
import ReminderModal from "./ReminderModal";
import { Box, Checkbox, Chip, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, TextField } from "@mui/material";
import ParametriValutativi from "./ParametriValutativi";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import VideoTrack from "./VideoTrack";
import JsonUpload from "./JsonUpload";
import Video3DTrack from "./Video3DTrack";

import strechingHuman from "../assets/icons/strechingHuman.svg"
import elasticBand from "../assets/icons/elasticBand.svg"
import elasticRope from "../assets/icons/elasticRope.svg"
import doubleHandleMedicineBall from "../assets/icons/doubleHandleMedicineBall.svg"
import barbell from "../assets/icons/barbell.svg"
import dumpbell from "../assets/icons/dumpbell.svg"
import bench from "../assets/icons/bench.svg"
import foamRoller from "../assets/icons/foamRoller.svg"
import disk from "../assets/icons/disk.svg"
import broomStick from "../assets/icons/broomStick.svg"

interface EsercizioDetailsProps {
    //token: string;
    esercizio: Esercizio;
    handleChange: <K extends keyof Esercizio>(key: K, value: Esercizio[K]) => void;
}

interface ReminderOption {
    id: number | null;
    name: string;
    description: string;
}

interface select {
    id: number | null;
    name: string;
    icon?: string;
    description?: string
}


const iconMap: any = {
    elasticBand,
    elasticRope,
    doubleHandleMedicineBall,
    barbell,
    dumpbell,
    bench,
    foamRoller,
    disk,
    broomStick
};


export default function EsercizioDetailsFast({ esercizio, handleChange }: EsercizioDetailsProps) {
    const fileInputRef = useRef<HTMLInputElement | null>(null);


    const [modalEF, setModalEF] = useState<boolean>(false);
    const [modalComplexFunction, setModalComplexFunction] = useState<boolean>(false);
    const [modalIssues, setModalIssues] = useState<boolean>(false);
    const [modalReminder, setModalReminder] = useState<boolean>(false);

    const [reminderOptions, setReminderOptions] = useState<ReminderOption[]>([]);
    const [complex_functionOptions, setComplex_functionOptions] = useState<select[]>([]);
    const [equipmentOptions, setEquipmentOptions] = useState<select[]>([]);
    const [issue_forOptions, setIssue_forOptions] = useState<select[]>([]);



    const toggleReminder = (id: number) => {
        const isAlreadySelected = esercizio.reminders.includes(id);
        if (!isAlreadySelected && esercizio.reminders.length > 5) return;

        const updatedReminders = isAlreadySelected
            ? esercizio.reminders.filter(reminderId => reminderId !== id)
            : [...esercizio.reminders, id];

        handleChange("reminders", updatedReminders);
    };

    const handleSelectChangeReminder = (event: any) => {
        const {
            target: { value },
        } = event;

        const previous = esercizio.reminders ?? [];
        const newValue = typeof value === "string" ? value.split(",") : value;

        const added = newValue.find((id: any) => !previous.includes(id));
        const removed = previous.find((id) => !newValue.includes(id));

        if (added !== undefined) {
            toggleReminder(added);
        } else if (removed !== undefined) {
            toggleReminder(removed);
        }
    };


    const fetchReminders = async () => {
        try {
            const headers = new Headers();
            //if (token) {
            //    headers.set('Authorization', `Token ${token}`);
            //}
            headers.set('Accept', 'application/json');
            const requestInit: RequestInit = {
                method: 'GET',
                headers: headers,
                credentials: 'include',
            }
            const response = await fetch('/api/v0/reminders', requestInit);
            if (!response.ok) throw new Error('Errore nel recupero delle attività');
            const data: ReminderOption[] = await response.json();
            setReminderOptions(data);
        } catch (err: any) {
            console.log(err.message);
        }
    };

    const handleEvaluationalParamsChange = (group: string, newParams: { key: string; value: number }[]) => {
        const key = ("evaluation_params_" + group) as keyof Esercizio;
        handleChange(key, newParams);
    };

    const fetchIssues = async () => {
        try {
            const headers = new Headers();
            //if (token) {
            //    headers.set('Authorization', `Token ${token}`);
            //}
            headers.set('Accept', 'application/json');
            const requestInit: RequestInit = {
                method: 'GET',
                headers: headers,
                credentials: 'include',
            }
            const response = await fetch('/api/v0/issues', requestInit);
            if (!response.ok) throw new Error('Errore nel recupero delle attività');
            const data: ReminderOption[] = await response.json();
            setIssue_forOptions(data);
        } catch (err: any) {
            console.log(err.message);
        }
    };

    const fetchEquipment = async () => {
        try {
            const headers = new Headers();
            //if (token) {
            //    headers.set('Authorization', `Token ${token}`);
            //}
            headers.set('Accept', 'application/json');
            const requestInit: RequestInit = {
                method: 'GET',
                headers: headers,
                credentials: 'include',
            }
            const response = await fetch('/api/v0/equipments', requestInit);
            if (!response.ok) throw new Error('Errore nel recupero delle attività');
            const data: ReminderOption[] = await response.json();
            setEquipmentOptions(data);
        } catch (err: any) {
            console.log(err.message);
        }
    };

    const fetchComplex_function = async () => {
        try {
            const headers = new Headers();
            headers.set('Accept', 'application/json');

            const requestInit: RequestInit = {
                method: 'GET',
                headers: headers,
                credentials: 'include',
            };

            const response = await fetch('/api/v0/complex-functions', requestInit);
            if (!response.ok) throw new Error('Errore nel recupero delle attività');

            const data: ReminderOption[] = await response.json();
            setComplex_functionOptions(data);

            if (
                esercizio.complex_function !== null &&
                !data.some(option => option.id === esercizio.complex_function)
            ) {
                handleChange("complex_function", null);
            }
        } catch (err: any) {
            console.log(err.message);
        }
    };


    useEffect(() => {
        var newissue = esercizio.recommended_for.filter(id =>
            issue_forOptions.some(option => option.id === id)
        );
        if (newissue.length !== esercizio.recommended_for.length) {
            handleChange("recommended_for", newissue);
        }
        newissue = esercizio.contraindicated_for.filter(id =>
            issue_forOptions.some(option => option.id === id)
        );
        if (newissue.length !== esercizio.contraindicated_for.length) {
            handleChange("contraindicated_for", newissue);
        }
    }, [issue_forOptions]);

    useEffect(() => {
        if (
            esercizio.complex_function !== null &&
            !complex_functionOptions.some(option => option.id === esercizio.complex_function)
        ) {
            handleChange("complex_function", null);
        }
    }, [complex_functionOptions]);

    useEffect(() => {
        const updatedReminders = esercizio.reminders.filter(id =>
            reminderOptions.some(option => option.id === id)
        );
        if (updatedReminders.length !== esercizio.reminders.length) {
            handleChange("reminders", updatedReminders);
        }
    }, [reminderOptions]);


    useEffect(() => {
        fetchIssues()
        fetchComplex_function()
        fetchReminders()
        fetchEquipment();
    }, []);

    return (
        <div className="mt-3 p-3 bg-white shadow-md rounded-lg max-w-lg mx-auto" style={{ height: "calc(86vh - 100px)", overflowY: "auto" }}>
            <div className="d-flex mt-1 mb-4">
                <button className="btn btn-dark me-2" onClick={() => setModalEF(!modalEF)}>
                    <AddIcon />
                </button>
                <ModalPosizioneFinalita
                    open={modalEF}
                    onClose={() => setModalEF(false)}
                    esercizio={esercizio}
                    positionChange={(e) => handleChange("position", e.value)}
                    purposeChange={(e) => handleChange("purpose", e.value)}
                />
                <TextField
                    disabled
                    fullWidth
                    variant="outlined"
                    size="small"
                    className="form-control"
                    label="Posizione*"
                    value={esercizio.position}

                />
                <div className="m-1">
                    <ArrowForwardIosIcon />
                </div>
                <TextField
                    disabled
                    fullWidth
                    variant="outlined"
                    size="small"
                    className="form-control"
                    label="Finalità*"
                    value={finalita.map((option) =>
                        esercizio.purpose === option.value ? option.name : undefined
                    ).filter(Boolean)}
                />
            </div>

            <EsercizioCorrelato
                current_id={esercizio.id!}
                esercizioCorrelato={esercizio.esercizio_correlato ? esercizio.esercizio_correlato : 0}
                onChange={(value) => {
                    handleChange("esercizio_correlato", value)
                }}
            />
            <TextField
                label="Nome corto*"
                variant="outlined"
                size="small"
                fullWidth
                value={esercizio.full_name}
                onChange={(e) => handleChange("full_name", e.target.value)}
                inputProps={{ maxLength: 35 }}
                helperText={`${esercizio.full_name.length}/35`}
                FormHelperTextProps={{ style: { textAlign: 'right' } }}
                className="mb-2"
            />
            <TextField
                label="Nome vocale"
                variant="outlined"
                size="small"
                fullWidth
                value={esercizio.vocal_name}
                onChange={(e) => handleChange("vocal_name", e.target.value)}
                inputProps={{ maxLength: 4000 }}
                className="mb-4"
            />
            <TextField
                label="Descrizione*"
                variant="outlined"
                size="small"
                fullWidth
                multiline
                minRows={2}
                value={esercizio.full_description}
                onChange={(e) => handleChange("full_description", e.target.value)}
                InputProps={{
                    sx: {
                        maxHeight: 300,
                        overflow: "auto"
                    }
                }}
                inputProps={{
                    maxLength: 250,
                    style: {
                        maxHeight: 300
                    }
                }}
                helperText={`${esercizio.full_description.length}/250`}
                FormHelperTextProps={{ style: { textAlign: 'right' } }}
                className="mb-2"
            />
            <TextField
                label="Descrizione vocale"
                variant="outlined"
                size="small"
                fullWidth
                multiline
                minRows={2}
                value={esercizio.vocal_description}
                onChange={(e) => handleChange("vocal_description", e.target.value)}
                InputProps={{
                    sx: {
                        maxHeight: 300,
                        overflow: "auto"
                    }
                }}
                inputProps={{
                    maxLength: 2000,
                    style: {
                        maxHeight: 300
                    }
                }}
                className="mb-4"
            />

            <FormControl fullWidth size="small" className="mb-4">
                <InputLabel id="mode-label">Esecuzione*</InputLabel>
                <Select
                    labelId="mode-label"
                    value={esercizio.execution}
                    label="Esecuzione*"
                    onChange={(e) => handleChange("execution", e.target.value)}
                >
                    {esecuzioni.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>


            <FormControl fullWidth size="small" className="mb-4">
                <InputLabel id="mode-label">Modalità*</InputLabel>
                <Select
                    labelId="mode-label"
                    value={esercizio.mode}
                    label="Modalità*"
                    onChange={(e) => handleChange("mode", e.target.value)}
                >
                    {modalita.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            <FormControl fullWidth size="small" className="mb-4">
                <InputLabel id="mode-label">Comparto*</InputLabel>
                <Select
                    labelId="mode-label"
                    value={esercizio.muscle_groups}
                    label="Comparto*"
                    onChange={(e) => handleChange("muscle_groups", e.target.value)}
                >
                    {comparti.map((e) => (
                        <MenuItem key={e.value} value={e.value}>
                            {e.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            <FormControl fullWidth size="small" className="mb-4">
                <InputLabel id="mode-label">Assetto*</InputLabel>
                <Select
                    labelId="mode-label"
                    value={esercizio.posture}
                    label="Assetto*"
                    onChange={(e) => handleChange("posture", e.target.value)}
                >
                    {assetti.map((e) => (
                        <MenuItem key={e.value} value={e.value}>
                            {e.name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            <div className="row mb-4">
                <div className="col d-flex">
                    <FormControl fullWidth size="small" margin="normal" className="form-control me-3">
                        <InputLabel id="complex-function-label">Funzione complessa</InputLabel>
                        <Select
                            labelId="complex-function-label"
                            value={esercizio.complex_function ?? ''}
                            label="Scegli una funzione"
                             onChange={(e) => handleChange("complex_function", e.target.value === '' ? null : Number(e.target.value))}
                        >
                            <MenuItem key="none" value="">
                                Nessuna
                            </MenuItem>
                            {complex_functionOptions.map((option) => (
                                option.id &&
                                <MenuItem key={option.id} value={option.id}>
                                    {option.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <button className="btn btn-light mb-2 mt-3" onClick={() => setModalComplexFunction(!modalComplexFunction)}>
                        <ModeIcon />
                    </button>
                    <ComplexFunctionModal
                        //token={token}
                        open={modalComplexFunction}
                        onClose={() => setModalComplexFunction(false)}
                        list={complex_functionOptions}
                        setList={setComplex_functionOptions}
                    />
                </div>
            </div>


            <FormControl fullWidth size="small" className="mb-4">
                <InputLabel id="mode-label">Attrezzo*</InputLabel>
                <Select
                    labelId="mode-label"
                    value={esercizio.equipment && esercizio.equipment[0] ? esercizio.equipment[0] : 0}
                    label="Attrezzo*"
                    onChange={(e) => {
                        const selected = Number(e.target.value);
                        handleChange("equipment", selected === 0 ? [] : [selected]);
                    }}
                >
                    <MenuItem key={0} value={0}>
                        <img src={strechingHuman} alt="icon" width={30} className="me-3" />
                        Solo carico naturale
                    </MenuItem>
                    {equipmentOptions.map((e) => (
                        e.id && e.id !== 0 ? (
                            <MenuItem key={e.id} value={e.id}>
                                <img src={iconMap[e.icon ? e.icon : ""]} alt="icon" width={30} className="me-3" />
                                {e.name}
                            </MenuItem>
                        ) : null
                    ))}
                </Select>
            </FormControl>

            {esercizio.equipment && esercizio.equipment.length > 0 && (
                <FormControl fullWidth size="small" className="mb-4">
                    <InputLabel id="second-equipment-label">Secondo attrezzo</InputLabel>
                    <Select
                        labelId="second-equipment-label"
                        value={esercizio.equipment[1] || ""}
                        label="Secondo attrezzo"
                        onChange={(e) => {
                            const second = Number(e.target.value);
                            if (second === -1) {
                                handleChange("equipment", [esercizio.equipment[0]]);
                            } else {
                                handleChange("equipment", [esercizio.equipment[0], second]);
                            }
                        }}
                    >
                        <MenuItem key={-1} value={-1}>
                            Nessuno
                        </MenuItem>
                        {equipmentOptions.map((e) =>
                            e.id && e.id !== 0 && e.id !== esercizio.equipment[0] ? (
                                <MenuItem key={e.id} value={e.id}>
                                    <img src={iconMap[e.icon ? e.icon : ""]} alt="icon" width={30} className="me-3" />
                                    {e.name}
                                </MenuItem>
                            ) : null
                        )}
                    </Select>
                </FormControl>
            )}

            <div className="row mb-4">
                <div className="col d-flex">
                    <FormControl fullWidth size="small" margin="normal" className="form-control me-3">
                        <InputLabel id="recommended-for-label">Raccomandato per</InputLabel>
                        <Select
                            labelId="recommended-for-label"
                            multiple
                            value={esercizio.recommended_for ?? []}
                            onChange={(e) => {
                                const selectedValues = e.target.value as number[];
                                handleChange("recommended_for", selectedValues)
                            }}
                            input={<OutlinedInput label="Raccomandato per" />}
                            renderValue={(selected) =>
                                issue_forOptions
                                    .filter((option) => selected.includes(option.id ? option.id : -1))
                                    .map((option) => option.name)
                                    .join(", ")
                            }
                        >
                            {issue_forOptions.map((option) => (
                                option.id &&
                                <MenuItem key={option.id} value={option.id}>
                                    <Checkbox
                                        checked={esercizio.recommended_for?.includes(option.id) ?? false}
                                    />
                                    <ListItemText primary={option.name} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <button className="btn btn-light mb-2 mt-3" onClick={() => setModalIssues(!modalIssues)}>
                        <ModeIcon />
                    </button>
                </div>
            </div>

            <div className="row mb-4">
                <div className="col d-flex">
                    <FormControl fullWidth size="small" margin="normal" className="form-control me-3">
                        <InputLabel id="contraindicated-for-label">Controindicato per</InputLabel>
                        <Select
                            labelId="contraindicated-for-label"
                            multiple
                            value={esercizio.contraindicated_for ?? []}
                            onChange={(e) => {
                                const selectedValues = e.target.value as number[];
                                handleChange("contraindicated_for", selectedValues)
                            }}
                            input={<OutlinedInput label="Controindicato per" />}
                            renderValue={(selected) =>
                                issue_forOptions
                                    .filter((option) => selected.includes(option.id ? option.id : -1))
                                    .map((option) => option.name)
                                    .join(", ")
                            }
                        >
                            {issue_forOptions.map((option) => (
                                option.id &&
                                <MenuItem key={option.id} value={option.id}>
                                    <Checkbox
                                        checked={esercizio.contraindicated_for?.includes(option.id) ?? false}
                                    />
                                    <ListItemText primary={option.name} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <button className="btn btn-light mb-2 mt-3" onClick={() => setModalIssues(!modalIssues)}>
                        <ModeIcon />
                    </button>
                    <IssueHandlingModal
                        open={modalIssues}
                        onClose={() => setModalIssues(false)}
                        list={issue_forOptions}
                        setList={setIssue_forOptions}
                    />
                </div>
            </div>


            <div className="mb-3">
                <ProgressBarODM
                    title="Complessità gestione gravitaria*"
                    levels={5}
                    field="gravity_management_complexity"
                    value={esercizio.gravity_management_complexity}
                    onChange={handleChange}
                />
                <ProgressBarODM
                    title="Complessità coordinazione motoria*"
                    levels={5}
                    field="motor_coordination_complexity"
                    value={esercizio.motor_coordination_complexity}
                    onChange={handleChange}
                />
                <ProgressBarODM
                    title="Intensità cardio-respiratoria*"
                    levels={5}
                    field="cardiorespiratory_complexity"
                    value={esercizio.cardiorespiratory_complexity}
                    onChange={handleChange}
                />
            </div>

            <div className="mb-5">
                <ParametriValutativi
                    value_cgg={esercizio.evaluation_params_cgg}
                    value_ccm={esercizio.evaluation_params_ccm}
                    value_icr={esercizio.evaluation_params_icr}
                    onChange={handleEvaluationalParamsChange}
                />
            </div>



            <div className="row mb-4">
                <div className="col d-flex">
                    <FormControl fullWidth size="small" margin="normal" className="form-control me-3">
                        <InputLabel id="reminder-label">Reminder durante l'esecuzione (Max 6)</InputLabel>
                        <Select
                            labelId="reminder-label"
                            multiple
                            value={esercizio.reminders ?? []}
                            onChange={handleSelectChangeReminder}
                            input={<OutlinedInput label="Reminder" />}
                            renderValue={() => ''}
                        >
                            {reminderOptions.map((option) => (
                                option.id &&
                                <MenuItem key={option.id} value={option.id}>
                                    <Checkbox checked={esercizio.reminders?.includes(option.id)} />
                                    <ListItemText primary={option.name} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <button className="btn btn-light mb-2 mt-3" onClick={() => setModalReminder(!modalReminder)}>
                        <ModeIcon />
                    </button>
                    <ReminderModal
                        open={modalReminder}
                        onClose={() => setModalReminder(false)}
                        list={reminderOptions}
                        setList={setReminderOptions}
                    />
                </div>
            </div>

            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: -1, mb: 5 }}>
                {(esercizio.reminders ?? []).map((id) => {
                    const selectedOption = reminderOptions.find((opt) => opt.id === id);
                    if (!selectedOption) return null;

                    return (
                        <Chip
                            key={id}
                            label={selectedOption.name}
                            onDelete={() =>
                                handleSelectChangeReminder({
                                    target: {
                                        value: (esercizio.reminders ?? []).filter((rem) => rem !== id),
                                    },
                                })
                            }
                        />
                    );
                })}
            </Box>

            <div className="mb-3">
                <h5 className="font-semibold mb-3">Immagine di anteprima</h5>
                <ImageUploadPreview
                    //token={token}
                    image={esercizio.preview_image}
                    onChange={(newImage) => {
                        handleChange("preview_image", newImage);
                        handleChange("filename_image", newImage ? newImage.name : null);
                    }}
                />
            </div>
            <div className="mb-3">
                <VideoTrack
                    title="Video"
                    description="Assicurati che il video riproduca una singola ripetizione dell'esercizio in quanto questa verrà ripetuta in loop sull'app."
                    acceptedFileType="video/mp4"
                    file={esercizio.video}
                    field="video"
                    handleChange={handleChange}
                    fast={true}
                />
            </div>
            <div className="mb-3">
                <Video3DTrack
                    title="Animazione 3D*"
                    description="Assicurati che l'animazione(.usdz) riproduca una singola ripetizione dell'esercizio in quanto questa verrà ripetuta in loop sull'app."

                    file={esercizio.animation}
                    field="animation"
                    handleChange={handleChange}
                    fast={true}
                    filename={esercizio.filename_animation}
                />
            </div>
            <div className="mb-3">
                <JsonUpload
                    title="Body tracking* (.json)"
                    description="Assicurato che i video da cui ha origine il file .json riproduca una singola ripetizione dell'esercizio in quanto questa verrà usata come modello del movimento ottimale."
                    acceptedFileType=".json"
                    file={esercizio.body_tracking}
                    field="body_tracking"
                    handleChange={handleChange}
                    fast={true}
                    filename={esercizio.filename_json}
                />
            </div>

        </div>

    );
}